/**
 * Ultra asset discovery.
 *
 * Deliberately free of any three.js import: this module has to be loadable
 * without dragging in the Ultra chunk (GTAO, SMAA, the HDR loader — ~110 kB
 * gzipped) that players on the other tiers never need. `main.js` asks this
 * whether the tier is worth offering, and only then dynamically imports the
 * rest.
 */

/**
 * Where `scripts/fetch-assets.mjs` puts what it downloads. Absolute so the
 * path resolves the same from /, /index.html and the Phoenix-served build.
 */
export const ULTRA_ASSET_BASE = '/gfx/';

let cached = null;

/**
 * Resolves to the manifest when the CC0 pack has been fetched, or null when
 * it has not. Never rejects — a missing pack is the expected state on a fresh
 * clone, not an error.
 */
export async function probeUltraAssets() {
  if (cached !== null) return cached.manifest;

  try {
    const res = await fetch(`${ULTRA_ASSET_BASE}manifest.json`, { cache: 'force-cache' });
    if (!res.ok) throw new Error(String(res.status));
    const manifest = await res.json();
    // A manifest with no textures is a half-finished fetch, not a usable set
    if (!manifest.textures || !Object.keys(manifest.textures).length) {
      throw new Error('empty manifest');
    }
    cached = { manifest };
  } catch {
    cached = { manifest: null };
  }
  return cached.manifest;
}
